import {ObjectLiteral} from "typeorm/browser/common/ObjectLiteral";
import {EntityTarget} from "typeorm/browser/common/EntityTarget";
import LocalDataSource from "../../data-sources/LocalDataSource";
import {HttpRepository} from "./HttpRepository";
import {Inject, Injectable} from "@angular/core";
import {IRepository} from "./IRepository";
import {LocalRepository} from "./LocalRepository";

@Injectable({ providedIn: 'root'})
export class FaunaDataSource {
  local = true// Capacitor.getPlatform() != "web"

  constructor(private httpRepo: HttpRepository<any>) {
  }
  getRepository<Entity extends ObjectLiteral>(target: EntityTarget<Entity>): IRepository<Entity>{
    if(this.local){
      return new LocalRepository(target)
    }
    else
      return this.httpRepo
  }
}
